import {InjectionToken} from '@angular/core';
import {FieldContainer} from './declarations';

export const FIELD_CONTAINER_TOKEN = new InjectionToken<FieldContainer>('FieldContainer');
